<p-toolbar styleClass="pb-0">
	<ng-template pTemplate="left">
		<!-- Recherche -->
		<div class="grid formgrid fluid w-full">
			<div class="field col-fixed pl-0">
				<div class="p-inputgroup mr-2">
					<input
						pInputText
						type="text"
						[(ngModel)]="search"
						(onDebounce)="refresh()"
						placeholder="{{'common.search_input_placeholder' | translate}}"
					/>
					<button type="button" class="p-inputgroup-addon" icon="pi pi-times" pButton label="" [disabled]="!search || loading" (click)="resetSearch()"></button>
				</div>
			</div>

			<div class="field col-fixed">
				<button
					type="button"
					pButton
					icon="pi pi-download"
					[label]="'common.export_action_label' | translate"
					(click)="exporterHistorique()"
				></button>
			</div>
		</div>
	</ng-template>
</p-toolbar>

<p-table
	#tableRubriques
	[value]="values"
	[lazy]="true"
	(onLazyLoad)="loadHistorique($event)"
	[loading]="loading"
	[paginator]="true"
	[rows]="rows"
	[showCurrentPageReport]="true"
	[totalRecords]="totalRecords"
	currentPageReportTemplate="{{totalRecords | number}} {{'common.table_total_records'|translate}}"
	[rowsPerPageOptions]="[10,25,50]"
	styleClass="p-datatable-sm p-datatable-gridlines table-scrollable-hover"
	[autoLayout]="true"
	responsiveLayout="scroll"
	scrollDirection="both"
	[scrollable]="true"
	scrollHeight="flex"
>
	<!-- Header -->
	<ng-template pTemplate="header">
		<tr>
			<th class="text-center">
				{{ 'common.modification_date_label' | translate }}
			</th>

			<th class="text-center">
				{{ 'rubriques.rubrique_label' | translate }}
			</th>

			<th class="text-center">
				{{ 'rubriques.active_state' | translate }}
			</th>

			<th class="text-center">
				{{ 'themes.theme_label' | translate }}
			</th>

			<th class="text-center">
				{{ 'families.family_label' | translate }}
			</th>

			<th class="text-center">
				{{ 'common.modifier_label' | translate }}
			</th>
		</tr>
	</ng-template>

	<ng-template pTemplate="body" let-rubrique>
		<tr>
			<td>{{rubrique.rdi_date | date:'short'}}</td>
			<td>{{rubrique.rub_nom}}</td>
			<td class="text-center">
				{{ rubrique.rdi_actif | yesno }}
			</td>
			<td>{{rubrique.thm_nom}}</td>
			<td>{{rubrique.fam_nom}}</td>
			<td>{{rubrique.uti_email}}</td>
		</tr>
	</ng-template>

</p-table>
